import { GET_CAR, GET_CARFACILTIES,GET_ADDCAR_REQUESTED,GET_DELETECAR_REQUESTED,GET_FACILITIES_REQUESTED ,GET_UPDATECAR_REQUESTED} from "resources/actionTypes";

export function getCar(data, type, setFilterValues, filterValues) {
  
  const payloadData = {
    data: data,
    type: type,
    setFilterValues: setFilterValues,
    filterValues: filterValues,
  };
  return {
    type: GET_CAR.GET_CAR_REQUESTED,
    payload: payloadData,
  };
}

export function clearCar() {
  return {
    type: GET_CAR.GET_CAR_CLEAR,
  };
}

export function getCarFacilities(data) {
  
  const payloadData = {
    data: data,
  };
  return {
    type: GET_CARFACILTIES.GET_CARFACILTIES_REQUESTED,
    payload: payloadData,
  };
}


export function postAddCar(userAddCar) {
  const data ={
    userAddCar:userAddCar,
  }
  return {
    type: GET_ADDCAR_REQUESTED,
    payload: data,
  };
}

export function patchUpdateCar(userUpdateCar) {
  const data ={
    userUpdateCar:userUpdateCar,
  }
  return {
    type: GET_UPDATECAR_REQUESTED,
    payload: data,
  };
}

export function deleteCar(userDeleteCar) {
  const data ={
    userDeleteCar:userDeleteCar,
  }
  return {
    type: GET_DELETECAR_REQUESTED,
    payload: data,
  };
}

export function getFacilities(id) {
  const data ={
    id:id,
  }
  return {
    type: GET_FACILITIES_REQUESTED,
    payload:data
  };
}
